(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["EHIModal"] = factory();
	else
		root["EHIModal"] = factory();
})(globalThis, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./styles.scss":
/*!*********************!*\
  !*** ./styles.scss ***!
  \*********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!******************!*\
  !*** ./index.js ***!
  \******************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./styles.scss */ "./styles.scss");

const React = window.React;
const ReactDOM = window.ReactDOM;
class EHIModal extends React.PureComponent {
  config = {
    id: 'ehi-modal',
    modalClass: '',
    modalHeaderClass: '',
    header: null,
    headerClass: '',
    subheader: null,
    subheaderClass: '',
    modalBodyContent: null,
    modalBodyClass: '',
    button: null,
    buttonClass: '',
    buttonDisabled: false,
    altButton: '',
    altButtonClass: 'no-style',
    altButtonDisabled: false,
    modalFooterClass: '',
    cancelButton: true,
    backdropClass: '',
    destroyOnCancel: true,
    afterComponentDidMount: null,
    afterComponentWillUnmount: null,
    afterComponentDidUpdate: null,
    mountModalBodyContent: () => {
      return;
    },
    onDestroyCallback: null,
    onAfterButtonClick: null,
    onAfterAltButtonClick: null,
    onAfterCancelButtonClick: null
  };
  modalRef = React.createRef();
  headerRef = React.createRef();
  bodyRef = React.createRef();
  footerRef = React.createRef();
  backdropRef = React.createRef();
  state = {
    active: false
  };
  constructor(props) {
    super(props);
    if (props.config) {
      Object.keys(this.config).forEach(key => {
        this.config[key] = typeof props.config[key] !== 'undefined' ? props.config[key] : this.config[key];
      });
    }
  }
  componentDidMount() {
    this.on('ehi-modal:show', this.onModalShow);
    this.on('ehi-modal:hide', this.onModalHide);
    if (typeof this.mountModalBodyContent == 'function') {
      this.mountModalBodyContent();
    } else if (this.config.mountModalBodyContent == 'function') {
      this.config.mountModalBodyContent();
    }
    if (typeof this.afterComponentDidMount == 'function') {
      this.afterComponentDidMount();
    } else if (typeof this.config.afterComponentDidMount == 'function') {
      this.config.afterComponentDidMount();
    }
  }
  componentWillUnmount() {
    this.off('ehi-modal:show', this.onModalShow);
    this.off('ehi-modal:hide', this.onModalHide);
    if (typeof this.afterComponentWillUnmount == 'function') {
      this.afterComponentWillUnmount();
    } else if (typeof this.config.afterComponentWillUnmount == 'function') {
      this.config.afterComponentWillUnmount();
    }
  }
  componentDidUpdate() {
    if (typeof this.afterComponentDidUpdate == 'function') {
      this.afterComponentDidMount();
    } else if (typeof this.config.afterComponentDidUpdate == 'function') {
      this.config.afterComponentDidMount();
    }
  }
  componentDidCatch(error, info) {
    console.error(error, info);
  }

  /* ---------------------------
     State Helpers
  ---------------------------- */
  isActive = () => {
    return this.state.active;
  };
  isHidden = () => {
    return !this.state.active && this.modalRef.current?.getAttribute('aria-hidden') === 'true' && this.backdropRef.current?.getAttribute('aria-hidden') === 'true' ? false : true;
  };
  isVisible = () => {
    return this.state.active && this.modalRef.current?.getAttribute('aria-hidden') === 'false' && this.backdropRef.current?.getAttribute('aria-hidden') === 'false' ? true : false;
  };

  /* ---------------------------
     Visibility Controls
  ---------------------------- */
  show = () => {
    this.setState({
      active: true
    });
  };
  hide = () => {
    this.setState({
      active: false
    });
  };
  destroy = () => {
    this.setState({
      active: false
    });
    if (typeof this.config.onDestroyCallback == 'function') {
      this.config.onDestroyCallback();
    } else {
      this.modalRef.current.parentNode.removeChild(this.modalRef.current);
      this.modalRef = null;
      this.backdropRef.current.parentNode.removeChild(this.backdropRef.current);
      this.backdropRef = null;
    }
  };

  /* ---------------------------
     Custom Event System
  ---------------------------- */
  trigger = (eventName, detail = {}) => {
    this.modalRef.current?.dispatchEvent(new CustomEvent(eventName, {
      detail
    }));
  };
  on = (eventName, callback) => {
    this.modalRef.current?.addEventListener(eventName, callback);
  };
  off = (eventName, callback) => {
    this.modalRef.current?.removeEventListener(eventName, callback);
  };

  /* ---------------------------
     Native Event Handlers
  ---------------------------- */
  onModalShow = event => {
    this.show();
  };
  onModalHide = event => {
    this.hide();
  };
  onButtonClick = event => {
    if (event.type !== 'click') {
      return;
    }
    document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', {
      detail: {
        action: 'modal_button_click'
      }
    }));
    this.trigger('ehi-modal:buttonClick');
    if (typeof this.onAfterButtonClick == 'function') {
      this.onAfterButtonClick(event);
    } else if (typeof this.config.onAfterButtonClick == 'function') {
      this.config.onAfterButtonClick(event);
    }
  };
  onAltButtonClick = event => {
    if (event.type !== 'click') {
      return;
    }
    document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', {
      detail: {
        action: 'modal_button_click'
      }
    }));
    this.trigger('ehi-modal:altButtonClick');
    if (typeof this.onAfterAltButtonClick == 'function') {
      this.onAfterAltButtonClick(event);
    } else if (typeof this.config.onAltButtonClick == 'function') {
      this.config.onAfterAltButtonClick(event);
    }
  };
  onCancelButtonClick = event => {
    if (event.type !== 'click') {
      return;
    }
    document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', {
      detail: {
        action: 'close_modal'
      }
    }));
    this.trigger('ehi-modal:cancelButtonClick');
    if (this.config.destroyOnCancel) {
      this.destroy();
    } else {
      this.hide();
    }
    if (typeof this.onAfterCancelButtonClick == 'function') {
      this.onAfterCancelButtonClick(event);
    } else if (typeof this.config.onAfterCancelButtonClick == 'function') {
      this.config.onAfterCancelButtonClick(event);
    }
  };

  /* ---------------------------
     Render
  ---------------------------- */
  renderModal() {
    const config = this.config;
    const {
      active
    } = this.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      ref: this.modalRef,
      id: config.id,
      className: `ehi-modal ${config.modalClass}`,
      tabIndex: -1,
      role: "dialog",
      "aria-hidden": !active
    }, /*#__PURE__*/React.createElement("div", {
      className: "ehi-modal-dialog",
      role: "document"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ehi-modal-content"
    }, /*#__PURE__*/React.createElement("div", {
      ref: this.headerRef,
      className: `ehi-modal-header ${config.modalHeaderClass}`
    }, config.header && /*#__PURE__*/React.createElement("h3", {
      className: config.headerClass
    }, config.header), config.subheader && /*#__PURE__*/React.createElement("h5", {
      className: config.subheaderClass
    }, config.subheader)), /*#__PURE__*/React.createElement("div", {
      ref: this.bodyRef,
      className: `ehi-modal-body ${config.modalBodyClass}`
    }, config.button && /*#__PURE__*/React.createElement("div", {
      className: "button-container"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: config.buttonClass,
      disabled: config.buttonDisabled,
      onClick: this.onButtonClick
    }, config.button))), /*#__PURE__*/React.createElement("div", {
      ref: this.footerRef,
      className: `ehi-modal-footer ${config.modalFooterClass}`
    }, config.altButton && /*#__PURE__*/React.createElement("div", {
      className: "alt-button-container"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: config.altButtonClass,
      disabled: config.altButtonDisabled,
      onClick: this.onAltButtonClick
    }, config.altButton)), config.cancelButton && /*#__PURE__*/React.createElement("div", {
      className: "cancel-button-container"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "cancel",
      onClick: this.onCancelButtonClick
    }, "Cancel")))))), /*#__PURE__*/React.createElement("div", {
      ref: this.backdropRef,
      id: "ehi-modal-backdrop",
      className: `ehi-modal-backdrop ${config.backdropClass}`,
      "aria-hidden": !active
    }));
  }
  render() {
    return ReactDOM.createPortal(this.renderModal(), document.body);
  }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EHIModal);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=ehi-modal.js.map